import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`

  @import url('https://fonts.googleapis.com/css?family=Montserrat:400,600&display=swap');

  *,
  *::after,
  *::before {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
  }

  html {
    font-size: 62.5%;
    max-width: 500px;
    background-color: #333;
  }

  body {
    box-sizing: border-box;
    font-family: 'Montserrat', Helvetica, sans-serif;
    padding-bottom: 50px;
    font-size: 2rem;
    background-color: #fff;
    min-height: 100vh;
  }
  button {
    all: unset;
  }
  ul, ol {
    list-style: none;
  }
`

export default GlobalStyles
